<template>
  <div>
    <nut-navbar :leftShow="leftBtn"
                :rightShow="false"
                @on-click-back="back">
      {{title}}
      <a slot="back-icon">
        <img class="back_icon"
             src="@/assets/images/Return@2x.png"
             alt="">
      </a>
      <a slot="back-icon"
         style="margin-left:15px;">
        <img class="home_icon"
             @click.shop="goHome"
             src="@/assets/images/homeone@2x.png">
      </a>
    </nut-navbar>
  </div>
</template>

<script>
export default {
  name: 'searchNavbar',
  props: {
    title: String,
    leftBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    goHome () {
      this.$router.push({ name: 'index' })
    },
  }
}
</script>

<style lang="scss" scoped>
.back_icon {
  width: 11px;
  height: 19px;
  vertical-align: middle;
}
.home_icon {
  width: 19px;
  height: 19px;
  vertical-align: middle;
  padding-left: 10px;
  border-left: 2px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbars/titleNavbar.vue